module.exports = __webpack_public_path__ + "static/media/Andreea Lucia Dumbrava.49b5a7c6.png";